module.exports = __webpack_public_path__ + "static/media/home.eeea3d3b.gif";